<div class="sidebar" #sidebar>
  <div class="logo-details">
    <img [src]="logoImageUrl" [class]="logoImageClass" alt="TeamLease Logo">
    <span class="logo_name"></span>
  </div>

  <ul class="nav-links"  [ngClass]="{'expanded': sidebarTabMenuToggle}">

    <li *ngFor="let link of navLinks" class="nav-links-item">

  <ng-container *ngIf="link.children?.length > 0; else singleMenu">

    <div class="sidebar-parent-item"
         [class.expanded]="link.isOpen">

      <!-- Parent -->
      <a class="sidebar-parent-link"
         (click)="toggleParent(link)">

        <img [src]="'../../assets/vectors/' + link.icon + '.svg'"
             class="sidebar-parent-icon">

        <div class="sidebar-parent-content">
          <span class="sidebar-parent-name">{{ link.name }}</span>

          <span class="sidebar-toggle"
                *ngIf="link.children?.length"
                [class.expanded]="link.isOpen">
          </span>
        </div>
      </a>

      <!-- Child Container -->
      <div class="sidebar-child-container"
           [class.expanded]="link.isOpen"
           *ngIf="link.isOpen">

        <ul class="sidebar-child-list">

          <li *ngFor="let child of link.children"
              class="sidebar-child-item">

            <a class="sidebar-child-link"
               (click)="onSubSidebarLinkClick(child.name, child.hrefurl)">

              <img *ngIf="child.icon" [src]="'../../assets/vectors/' + child.icon + '.svg'">

              <span class="sidebar-child-name" [title]="child.name">{{ child.name }}</span>

            </a>

          </li>

        </ul>

      </div>

    </div>

  </ng-container>

  <!-- Single Menu -->
  <ng-template #singleMenu>
    <a class="nav-links-item-a"
       (click)="onSidebarLinkClick(link.name, link.hrefurl)">
      <img [src]="'../assets/vectors/' + link.icon + '.svg'"
           class="nav-link-icons">
      <span class="links-name">{{ link.name }}</span>
    </a>
  </ng-template>

</li>


  </ul>
</div>

<section class="home-section">
    <nav class="navbar-fluid"
        style="display: flex; justify-content: space-between; align-items: center; position: relative; width: 100%; left: 0;">
        <div class="sidebar-button" style="color: #fff;">
            <i class="menu-btn" (click)="toggleSidebar(!sidebarActive);"><img
                    style="width: 25px;" [src]="toggleimg"></i>
            <span class="dashboard" *ngIf="currentRoute === '/ClientDashboard'" style="font-size: 15px;">
                {{clientName}}
            </span>
            <span class="dashboard"
                style="font-size: 15px;" *ngIf="showCustomerName()" >{{CustomerName}}</span>
            <span class="d-flex"
                *ngIf="(currentRoute === '/NoticeDetails' || currentRoute === '/SMEResponse' ||currentRoute === '/SDEXENotice' || currentRoute === '/NoticeDocumentSection')&&(Role === 'SME' || Role === 'SDEXE'||Role=='CORDN')"
                style="font-size: 15px; white-space: nowrap;">
                {{ entityText }}
            </span>

        </div>
        <div class="navbar-end" style="display: flex; align-items: center;  margin-right: -10px;">
            <i class="bx " title="Switch Customer"
                *ngIf="(Role =='SPSAD' ||Role =='SPAUD'||Role =='SPCON')  && currentRoute!='/CustomerDashboard'"
                style="color: #fff; font-size: 24px;  margin-right: 5px; "><img style="width: 35px;"
                    (click)="gotoEntityDashboard()" src="../assets/vectors/TransferNav.svg"></i>
            <i class="bx profile-icon toggle-Profile" title="Log Out" style="color: #fff; font-size: 24px;"><img
                    style="width: 35px;" (click)="toggleProfileDropdown()" src="../assets/vectors/Profile.svg"></i>
            <span (click)="toggleProfileDropdown()" class="user-name toggle-Profile"
                style="margin-left: 8px;color: white; font-weight: 500; font-size: 13px; cursor: pointer;"
                [title]="firstName + ' ' + lastName">
                {{ firstName }} {{ lastName }}
            </span>
            <i (click)="toggleProfileDropdown()" class=" fa fa-solid fa-caret-down toggle-Profile"
                aria-hidden="true"></i>
            <div *ngIf="showProfileDropdown" class="profile-dropdown">
                <ul>
                    <li title="Change Password" (click)="changePassword()">
                        <i class="fa fa-lock change-password-icon" style="padding-left: 5px;" aria-hidden="true"></i>
                        Change Password
                    </li>
                    <li title="Logout" (click)="logOut()">
                        <i class="fa fa-power-off change-password-icon" aria-hidden="true"></i>
                        Logout
                    </li>
                </ul>
            </div>
        </div>
    </nav>
    <br />
    <div class="container-fluid">
        <div class="container-content">

            <div class="container-fluid ">
                <ng-container *ngIf="hideTabs()">
                    <app-tabs></app-tabs>
                    <span>
                        <hr class="hr-fluid">
                    </span>
                </ng-container>
            </div>
            <router-outlet></router-outlet>
        </div>
    </div>
</section>

<app-alert-popup *ngIf="alertData.alertVisible" [Width]="250" [Height]="260" [Data]="alertData"
    (close)="closeAlert()"></app-alert-popup>